module.exports = __webpack_public_path__ + "static/media/footerImg.b24a0a99.png";